module.exports = __webpack_public_path__ + "img/house_active.35fd9500.svg";